module.exports = __webpack_public_path__ + "static/media/no-suitable.017c6459.svg";